import { ChangePassword, Login } from "@bs/login";
import { Login as LoginNestle } from "@bs/login-cargo-app-nestle"
import CryptoJS from 'crypto-js';
import { addLocale, locale } from 'primereact/api';
import { Dropdown } from 'primereact/dropdown';
import { lazy, Suspense, useContext, useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { BrowserRouter, Route, Routes, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import packageJson from '../package.json';
import './App.css';
import { PrivateRoute } from "./components";
import LayerControlSettingsMainComponent from "./components/LayerControlManagementPage/LayerControlSettingsMainComponent";
import LoadingPanel from "./components/LoadingPanel";
import { whereIsThisContext } from "./contexts/WhereIsThisContext";
import HandleCache from "./HandleCache";
import './i18n';
import { authenticationService, startupConfigurationService } from "./services";
import { history } from "./tools";
import { Button } from 'primereact/button';
const HomePage = lazy(() =>
    import("./pages").then((module) => ({ default: module.HomePage }))
);
// Türkçe yerelleştirme ekliyoruz
addLocale('tr', {
    startsWith: 'İle Başlayan',
    contains: 'İçeren',
    notContains: 'İçermeyen',
    endsWith: 'İle Biten',
    equals: 'Eşit',
    notEquals: 'Eşit Değil',
    noFilter: 'Filtre Yok',
    lt: 'Küçüktür',
    lte: 'Küçüktür veya Eşittir',
    gt: 'Büyüktür',
    gte: 'Büyüktür veya Eşittir',
    dateIs: 'Tarih Eşittir',
    dateIsNot: 'Tarih Eşit Değil',
    dateBefore: 'Tarih Öncesi',
    dateAfter: 'Tarih Sonrası',
    clear: 'Temizle',
    apply: 'Uygula',
    matchAll: 'Tümünü Eşleştir',
    matchAny: 'Herhangi Birini Eşleştir',
    addRule: 'Kural Ekle',
    removeRule: 'Kuralı Kaldır',
    accept: 'Evet',
    reject: 'Hayır',
    choose: 'Seçiniz',
    upload: 'Yükle',
    cancel: 'İptal',
    dayNames: ["Pazar", "Pazartesi", "Salı", "Çarşamba", "Perşembe", "Cuma", "Cumartesi"],
    dayNamesShort: ["Paz", "Pzt", "Sal", "Çar", "Per", "Cum", "Cmt"],
    dayNamesMin: ["Pz", "Pt", "Sa", "Ça", "Pe", "Cu", "Ct"],
    monthNames: ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"],
    monthNamesShort: ["Oca", "Şub", "Mar", "Nis", "May", "Haz", "Tem", "Ağu", "Eyl", "Eki", "Kas", "Ara"],
    today: 'Bugün',
    weekHeader: 'Hf',
    firstDayOfWeek: 1,
    dateFormat: 'dd/mm/yy',
    weak: 'Zayıf',
    medium: 'Orta',
    strong: 'Güçlü',
    passwordPrompt: 'Şifre Giriniz',
    emptyMessage: 'Kullanılabilir seçenek yok',
    emptyFilterMessage: 'Sonuç bulunamadı',
});

// Varsayılan dil olarak Türkçe'yi ayarla
locale('tr');
const baseUrl = process.env.PUBLIC_URL;
const LoginPage = () => {

    const { t, i18n } = useTranslation();

    const [selectedLanguage, setSelectedLanguage] = useState(i18n.language || 'tr');

    useEffect(() => {
        const lang = localStorage.getItem('lang');
        if (lang) {
            i18n.changeLanguage(lang);
            setSelectedLanguage(lang);
        }
    }, [i18n]);

    const languages = [
        { label: 'Türkçe', value: 'tr' },
        { label: 'English', value: 'en' }
    ];

    const changeLanguage = (lng) => {
        setSelectedLanguage(lng);
        i18n.changeLanguage(lng);
        localStorage.setItem('lang', lng);

    };
    const navigate = useNavigate();


    return (<>
        {/* <>
            <button type="button" onClick={() => changeLanguage('tr')}>
                tr
            </button>
            <button type="button" onClick={() => changeLanguage('en')}>
                en
            </button>
        </> */}

        <Button tooltip={t('homepage.menu.user_guide') }  style={{ position:"absolute" }} icon="pi pi-question-circle" link onClick={() => window.open(process.env.REACT_APP_USER_MANUEL + "/docs/login", '_blank')} />
        <LoginNestle url={process.env.REACT_APP_USER_API_URL}
            otp={true}
            otpUrl={process.env.REACT_APP_OTP_URL}
            otpValidateUrl={process.env.REACT_APP_OTP_VALIDATE_URL}
            onSuccess={(data) => {

                localStorage.setItem(process.env.REACT_APP_LS_TOKEN, data.token);

                authenticationService.getUserByToken(process.env.REACT_APP_USER_API_URL)
                    .then(response => {

                        localStorage.setItem(process.env.REACT_APP_LS_USER,
                            JSON.stringify(response.data));

                        startupConfigurationService.getStartupConfiguration(
                            process.env.REACT_APP_STARTUP_CONFIGURATION_API_URL)
                            .then(configurationResponse => {

                                localStorage.setItem("startupconfiguration", JSON.stringify(configurationResponse.data));
                                navigate("/");
                                //window.location.href = "/";
                            })
                            .catch(ex => {

                                toast.error(t('err_001_001_002'));
                            });
                    })
                    .catch(ex => {

                        toast.error(t('err_001_001_001'));
                    });
            }}
            localStorageUserKey={process.env.REACT_APP_LS_USER}
            theme="left"
            logo={`${process.env.PUBLIC_URL}/group_83.svg`}
            appName={t('lbl_001_001_001')}
            rememberMe={false}
            captcha={false}
            image={`${process.env.PUBLIC_URL}/basarsoft-cbs-hmp1.jpg`}
            version={"v" + packageJson.version}
            // bsEdevlet={true}
            // bsRegister={true}
            forgotPassword={false}
        />

        <div style={{ left: '18vw', bottom: '93vh', width: '4vw', minWidth: '120px', position: 'absolute',style:"none" }}>
            {/*<Dropdown*/}
            {/*    value={selectedLanguage}*/}
            {/*    options={languages}*/}
            {/*    onChange={(e) => changeLanguage(e.value)}*/}
            {/*    placeholder={t('lbl_001_001_002') || "Dil Seçin"}*/}
            {/*    className="w-full"*/}
            {/*/>*/}
        </div>

    


    </>)
}

//Tekil kontroller için kalmalı
window.Object.checkPermission = (permission) => {

    const user = JSON.parse(localStorage.getItem(process.env.REACT_APP_LS_USER));

    return user.permissions.includes(
        CryptoJS.enc.Base64.stringify(
            CryptoJS.enc.Utf8.parse(permission)));
}

window.Object.checkPermissions = (permissions) => {
    const user = JSON.parse(localStorage.getItem(process.env.REACT_APP_LS_USER));
    if (!user || !user.permissions) {
        return false;
    }

    return permissions.some(permission =>
        user.permissions.includes(
            CryptoJS.enc.Base64.stringify(
                CryptoJS.enc.Utf8.parse(permission)
            )
        )
    );
}

const App = () => {
    const [whereIsState, whereIsAction] = useContext(whereIsThisContext);
    return (

        <HandleCache>

            {({ isLoading, isLatestVersionAvailable, clearCacheAndReload }) => {
                if (isLoading) return null;

                if (!isLoading && !isLatestVersionAvailable) {
                    clearCacheAndReload();
                }

                return (

                    <div className={!whereIsState.isLoading ? "container" : "overlay"}>
                        <div id={!whereIsState.isLoading ? "" : "blur"}></div>
                        {whereIsState.isLoading && <LoadingPanel />}
                        <ToastContainer />
                        <BrowserRouter history={history}>
                            <Suspense fallback={<LoadingPanel />}>
                                <Routes>
                                    <Route path="/login" element={<LoginPage />} />
                                    <Route path="/reset-password" element={
                                        <ChangePassword url={process.env.REACT_APP_USER_API_URL} />} />
                                    <Route path="/" element={
                                        <PrivateRoute redirectPath="/login">
                                            <HomePage />
                                        </PrivateRoute>} />
                                    <Route path="*" element={<LoginPage />} />
                                    <Route path={baseUrl + "/layerControlSettings"} element={<LayerControlSettingsMainComponent />} />
                                </Routes>
                            </Suspense>
                        </BrowserRouter>
                    </div>
                )
            }}
        </HandleCache >
    );
}

export default App;
